
import React from 'react';
import Footers from "components/Footer/Footer.jsx";
const Footer = () => (
  <div>
    <Footers data={ <div>สำนักกำกับและอนุรักษ์พลังงาน โทร 02-223-0021 ต่อ 1411, 1407, 1669 และ 1323 โทรสาร 02-226-3943 อีเมล eform@dede.go.th</div>} />
    {/* <img src="images/contact.png" style={{ padding: "5px" }} /> */}
   {/* <div id="footer">
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td
              style={{
                backgroundImage: "url(images/footer_c2r1.png)",
                height: "3px"
              }}
            />
          </tr>
          <tr>
            <td
              style={{
                backgroundImage: "url(images/footer_c2r2.png)",
                height: "32px"
              }}
            >
              <img src="images/contact.png" style={{ padding: "5px" }} />
            </td>
          </tr>
          <tr>
            <td
              style={{
                backgroundImage: "url(images/footer_c2r3.png)",
                height: "15px"
              }}
            />
          </tr>
        </tbody>
      </table>
    </div>  */}
  </div>
);
export default Footer;


// WEBPACK FOOTER //
// ./src/layout/footer.js